import { Injector } from '@angular/core';
import { Transition, UIRouter } from '@uirouter/core';
import { AuthStateNames, AuthStatesHelper } from './authentication/router/auth-states';
import { APP_CONFIG, AppConfig } from 'src/environments/app-environment.models';

export class UIRouterConfig {
  /* UIRouter Config Function  */
  static async initialize(uiRouter: UIRouter, injector: Injector) {
    // Allow optional trailing slashes
    uiRouter.urlService.config.strictMode(false);

    // Acquire the settingsService
    const appConfig = injector.get<AppConfig>(APP_CONFIG);

    const transitionService = uiRouter.transitionService;
    transitionService.onStart({}, onStart);

    if (appConfig.debugConsoleEnabled) {
      transitionService.onSuccess({}, onSuccess);
      transitionService.onEnter({}, onEnter);
      transitionService.onError({}, onError);
      transitionService.onFinish({}, onFinish);
    }
  }
}

export function onStart(transition: Transition) {
  //clears redirect url from local storage if not transitioned to auth/redirect
  if (transition.to().name !== AuthStateNames.AuthRedirect) {
    AuthStatesHelper.clearAuthRedirectUrl();
  }

  console.debug(`transition:onStart: ${transition.from().name} -> ${transition.to().name}`);
}

export function onSuccess(transition: Transition) {
  console.debug(`transition:onSuccess: ${transition.from().name} -> ${transition.to().name}`);
}

export function onEnter(transition: Transition) {
  console.debug(`transition:onEnter: ${transition.from().name} -> ${transition.to().name}`);
}

export function onError(transition: Transition) {
  console.debug(`transition:onError: ${transition.from().name} -> ${transition.to().name}`, transition.error());
}

export function onFinish(transition: Transition) {
  console.debug(`transition:onFinish: ${transition.from().name} -> ${transition.to().name}`);
}
